var _desc, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcOpenLink(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_openLink") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-60.000000, -39.000000)",
    fill: "#697480"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5714286,47.4583333 L72.5714286,50.375 C72.5714286,51.8242188 71.4196429,53 70,53 L62.5714286,53 C61.1517857,53 60,51.8242188 60,50.375 L60,42.7916667 C60,41.3424479 61.1517857,40.1666667 62.5714286,40.1666667 L68.8571429,40.1666667 C69.0178571,40.1666667 69.1428571,40.2942708 69.1428571,40.4583333 L69.1428571,41.0416667 C69.1428571,41.2057292 69.0178571,41.3333333 68.8571429,41.3333333 L62.5714286,41.3333333 C61.7857143,41.3333333 61.1428571,41.9895833 61.1428571,42.7916667 L61.1428571,50.375 C61.1428571,51.1770833 61.7857143,51.8333333 62.5714286,51.8333333 L70,51.8333333 C70.7857143,51.8333333 71.4285714,51.1770833 71.4285714,50.375 L71.4285714,47.4583333 C71.4285714,47.2942708 71.5535714,47.1666667 71.7142857,47.1666667 L72.2857143,47.1666667 C72.4464286,47.1666667 72.5714286,47.2942708 72.5714286,47.4583333 Z M76,39.5833333 L76,44.25 C76,44.5690104 75.7410714,44.8333333 75.4285714,44.8333333 C75.2767857,44.8333333 75.1339286,44.7695312 75.0267857,44.6601562 L73.4553571,43.0559896 L67.6339286,48.9986979 C67.5803571,49.0533854 67.5,49.0898438 67.4285714,49.0898438 C67.3571429,49.0898438 67.2767857,49.0533854 67.2232143,48.9986979 L66.2053571,47.9596354 C66.1517857,47.9049479 66.1160714,47.8229167 66.1160714,47.75 C66.1160714,47.6770833 66.1517857,47.5950521 66.2053571,47.5403646 L72.0267857,41.5976562 L70.4553571,39.9934896 C70.3482143,39.8841146 70.2857143,39.7382812 70.2857143,39.5833333 C70.2857143,39.2643229 70.5446429,39 70.8571429,39 L75.4285714,39 C75.7410714,39 76,39.2643229 76,39.5833333 Z",
    id: "ic_openLink"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOpenLink);
export default __webpack_public_path__ + "static/media/ic-openLink.04be30ad8fb81223b704458f861fca24.svg";
export { ForwardRef as ReactComponent };